
// export const myGetter = ( state ) => {
//  return state
// }

export const statesList = state => state.states
export const statesSelectable = state => state.statesSelectable
export const statesPaginatedData = state => state.statesPaginatedData
export const state = state => state.state
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData